/**
 * OAuth error code → friendly copy (shared by popup callback routes AND parent toast).
 * Single source of truth per 24-UI-SPEC.md §OAuth error code → friendly copy mapping.
 * Mitigates T-24-04 by whitelisting known codes and sentence-casing unknown ones
 * (no HTML; plain text only — callers must render via React text children, never
 * dangerouslySetInnerHTML).
 */
export function oauthErrorToFriendly(code: string | undefined | null): string {
  if (!code) return 'Connection failed. Please try again.'
  switch (code) {
    case 'OAUTH_STATE_EXPIRED':
      return 'Session expired, please reconnect.'
    case 'OAUTH_STATE_BAD_SIGNATURE':
    case 'OAUTH_STATE_MALFORMED':
    case 'invalid_state':
      return 'Invalid OAuth response, please retry.'
    case 'connector_deleted':
      return 'Connector was deleted during connection, please recreate.'
    case 'token_persist_failed':
      return 'Could not save credentials, please retry.'
    case 'missing_params':
      return 'OAuth response was incomplete, please retry.'
    default: {
      const trimmed = code.replace(/_/g, ' ').trim()
      const cased = trimmed.charAt(0).toUpperCase() + trimmed.slice(1)
      return cased.replace(/\.?$/, '.')
    }
  }
}
